import apiClient from "../apiClient";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const CategoriesUpdate = () => {
    const [category, setCategory] = useState({
        Description: "",
        IsSavingsCategory: 0,
        IsIncomeCategory: 0,
    });
    const [error, setError] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const categoryId = location.pathname.split("/")[2];

    useEffect(() => {
        const fetchCategory = async () => {
            try {
                const res = await apiClient.get("/categories");
                const rows = Array.isArray(res.data) ? res.data : [];
                const current = rows.find((item) => String(item.CategoryId) === String(categoryId));
                if (!current) {
                    setError(true);
                    return;
                }
                setCategory({
                    Description: current.Description || "",
                    IsSavingsCategory: Number(current.IsSavingsCategory || 0),
                    IsIncomeCategory: Number(current.IsIncomeCategory || 0),
                });
            } catch (err) {
                setError(true);
            }
        };

        fetchCategory();
    }, [categoryId]);

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setCategory((prev) => ({ ...prev, [name]: type === "checkbox" ? (checked ? 1 : 0) : value }));
    };

    const handleClick = async(e) => {
        e.preventDefault();
        if (!category.Description?.trim()) return setError(true);
        try {
            await apiClient.put("/categories/" + categoryId, category);
            navigate("/Categories");
        } catch (err) {
            setError(true);
        }
     };
    
    return (
        <div className="page">
            <header className="page-header">
                <div>
                    <h1 className="page-title">Update Category</h1>
                    <p className="page-subtitle"><Link to="/">Home</Link> / <Link to="/Categories">Categories</Link> / Update</p>
                </div>
            </header>
            <section className="panel form-card">
                <div className="form">
                    <label htmlFor="category-description">Category Description</label>
                    <input
                        id="category-description"
                        type="text"
                        placeholder="Category Description"
                        name="Description"
                        value={category.Description}
                        onChange={handleChange}
                    />
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsSavingsCategory"
                            checked={Boolean(category.IsSavingsCategory)}
                            onChange={handleChange}
                        />
                        <span>Savings category</span>
                    </label>
                    <label className="checkbox-row">
                        <input
                            type="checkbox"
                            name="IsIncomeCategory"
                            checked={Boolean(category.IsIncomeCategory)}
                            onChange={handleChange}
                        />
                        <span>Income category</span>
                    </label>
                    <div className="form-actions">
                        <button className="btn" onClick={handleClick}>Update Category</button>
                        <Link className="btn-link" to="/Categories">Cancel</Link>
                    </div>
                    {error && <p className="notice notice-error">Could not update category. Check input and try again.</p>}
                </div>
            </section>
        </div>
         );
    };

export default CategoriesUpdate;
